import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

import Home from '../views/Home.vue'
import GiamSatTaiChinh from '../views/NghiepVu/GiamSatTaiChinh/GiamSatTaiChinh.vue'
import DanhGiaNDD from '../views/NghiepVu/DanhGiaNDD/DanhGiaNDD.vue'
import TongHopDtLnTlCt from '../views/NghiepVu/TongHopDtLnTlCt/TongHopDtLnTlCt.vue'
import NhapLieu from '../views/NghiepVu/NhapLieu/NhapLieu.vue'
import NhapLieuCty from '../views/NghiepVu/NhapLieu/NhapLieuCty.vue'
import Authen from '../views/Authen/Authen.vue'
import Http403 from '../views/Http/Http403.vue'
import TrangCaNhan from '../views/Account/TrangCaNhan.vue'
import DuyetNguoiDung from '../views/Account/DuyetNguoiDung.vue'

Vue.use(VueRouter)

function prefixWith (prefix: string, routeConfigs: Array<RouteConfig>): Array<RouteConfig> {
  return routeConfigs.map(routeConfig => {
    routeConfig.path = prefix + routeConfig.path
    return routeConfig
  })
}

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
  {
    path: '/authen',
    name: 'Authen',
    component: Authen,
  },
  {
    path: '/permission-denied',
    name: 'Http403',
    component: Http403,
  },
  ...prefixWith('/tai-khoan', [
    {
      path: '/trang-ca-nhan',
      name: 'TrangCaNhan',
      component: TrangCaNhan,
    },
    {
      path: '/duyet-nguoi-dung',
      name: 'DuyetNguoiDung',
      component: DuyetNguoiDung,
    },
  ]),
  ...prefixWith('/nghiep-vu', [
    ...prefixWith('/giam-sat-tai-chinh', [
      {
        path: '',
        name: 'GiamSatTaiChinh',
        component: GiamSatTaiChinh,
      },
    ]),
    ...prefixWith('/danh-gia-nguoi-dai-dien', [
      {
        path: '',
        name: 'DanhGiaNDD',
        component: DanhGiaNDD,
      },
    ]),
    ...prefixWith('/tong-hop-dt-ln-tl-ct', [
      {
        path: '',
        name: 'TongHopDtLnTlCt',
        component: TongHopDtLnTlCt,
      },
    ]),
    ...prefixWith('/nhap-lieu', [
      {
        path: '',
        name: 'NhapLieu',
        component: NhapLieu,
      },
      {
        path: '/:slug',
        name: 'NhapLieuCty',
        component: NhapLieuCty,
        props: true,
      },
    ])
  ])
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router

export const safeRoutes: Array<string> = [  // Routes that do not need authentication or authorization
  'Authen',
  'Http403',
]
